import * as Yup from "yup";

const login = { username: undefined, password: undefined };

const validation = () => {
    return Yup.object({ employee_id: Yup.string().required(("Field is required")), password: Yup.string().required(("Field is required")) });
};

export const loginInitialValue = login;
export const loginValidation = validation;
